<template>
	<div class="cassie-vertical-md">
		<div
			v-if="!rules.length"
			class="empty-state"
			data-testid="grouping-rule-list-empty"
		>
			{{ 'No grouping rules configured. Add a rule to get started.' | useLabels }}
		</div>
		<GroupingRuleCard
			v-for="(rule, index) in rules"
			:key="rule.id || `new-${index}`"
			:rule="rule"
			:order-number="index + 1"
			:index="index"
			:is-first="index === 0"
			:is-last="index === rules.length - 1"
			:user-full-permissions="userFullPermissions"
			@move-up="$emit('move-up', index)"
			@move-down="$emit('move-down', index)"
			@edit="$emit('edit', rule)"
			@delete="$emit('delete', rule)"
		/>
	</div>
</template>

<script>
import GroupingRuleCard from './GroupingRuleCard.vue'

export default {
	name: 'grouping-rule-list',
	components: { GroupingRuleCard },
	props: {
		rules: { type: Array, default: () => [] },
		userFullPermissions: { type: Boolean, default: false }
	}
}
</script>

<style scoped>
.empty-state {
	padding: var(--spacing-xl);
	text-align: center;
	color: var(--muted-foreground);
	background: var(--muted);
	border: 1px dashed var(--border);
	border-radius: var(--radius);
}
</style>
